






import { authObject, ui, firestore } from "@/scripts/firebase";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { auth } from "@/scripts/firebase";

@Component
export default class Auth extends Vue {
  mounted() {
    const signInConfig = {
      signInOptions: [authObject.EmailAuthProvider.PROVIDER_ID],
      signInSuccessUrl: this.from,
      privacyPolicyUrl: "privacy",
      tosUrl: "terms",
    };
    if (process.env.NODE_ENV === "production") {
      signInConfig.signInOptions.push(
        authObject.TwitterAuthProvider.PROVIDER_ID
      );
    }
    signInConfig.signInOptions.push(authObject.GoogleAuthProvider.PROVIDER_ID);

    ui.start("#firebaseui-auth-container", signInConfig);
  }

  get from(): string {
    if (this.$route.query.from) {
      return this.$route.query.from as string;
    }
    return "/j";
  }
}
